import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { PartnerState, Partner, PartnerRegistrationData } from '../../types';
import { partnerService } from '../../services/partnerService';

const initialState: PartnerState = {
  partners: [],
  currentPartner: null,
  registrationSuccess: false,
  isLoading: false,
  error: null,
};

// Async Thunks
export const registerPartner = createAsyncThunk(
  'partner/register',
  async (partnerData: PartnerRegistrationData, { rejectWithValue }) => {
    try {
      const response = await partnerService.registerPartner(partnerData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Registration failed');
    }
  }
);



const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearRegistrationSuccess: (state) => {
      state.registrationSuccess = false;
    },
    setCurrentPartner: (state, action: PayloadAction<Partner | null>) => {
      state.currentPartner = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Register Partner
    builder
      .addCase(registerPartner.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.registrationSuccess = false;
      })
      .addCase(registerPartner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentPartner = action.payload;
        state.registrationSuccess = true;
        state.partners.push(action.payload);
      })
      .addCase(registerPartner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.registrationSuccess = false;
      });

 
  },
});

export const { clearError, clearRegistrationSuccess, setCurrentPartner } = partnerSlice.actions;
export default partnerSlice.reducer;
